export const isInRange = (num: number, min: number, max: number): boolean => {
  return num >= min && num <= max;
};

export const validateDomainRegex = /^(?!-)([A-Za-z0-9-]{1,63}(?<!-)\.)+[A-Za-z]{2,6}$/;
